/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSideProps } from 'next';

import { PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { NEXT_PUBLIC_ENV_KEYS } from '@marriott/mi-leisure-components/constants';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';

function pageRenderer(props) {
  console.log('[sitemap] props ', props);
  return <PageRendererComponent {...props} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const sitemapSpecificData = async () => {
  const featureFlagAemltsHost = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LEISURE_RENDERER_AEMLTS_HOST, {
    target: TARGETS.APP.LEISURE_RENDERER,
    enableStream: true,
  });
  const useAemLtsHost = featureFlagAemltsHost?.experience_mcom_leisure_renderer_aemlts_host;
  const aemHost = useAemLtsHost ? process.env.NEXT_PUBLIC_AEM_LTS_HOST : process.env.NEXT_PUBLIC_AEM_HOST;
  return {
    operationSignatures: [],
    featureFlagAemltsHost: featureFlagAemltsHost ?? null,
    aemHost: aemHost ?? null,
    nextPublicEnvKeys: NEXT_PUBLIC_ENV_KEYS,
  };
};

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps: GetServerSideProps<any> = prePageCall(sitemapSpecificData);
export default pageRenderer;
